define('behavior/show.detail.on.table.row.double.press.behavior',['require','exports','module','underscore','marionette','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Mn          = require('marionette'),
      RouteHelper = require('fukit/fukit').RouteHelper;

  var _getRouteParams = function(params, model) {
    var routeParams = {};
    for (var i = 0; i < params.length; i++) {
      var currentParam = params[i];
      routeParams[currentParam.paramName] = currentParam.paramValue || model.get(currentParam.paramAttribute);
    }
    return routeParams;
  };

  var doublePressOptions;

  var ShowDetailOnTableRowDoublePressBehavior = Mn.Behavior.extend({
    defaults: {
      doublePressOptions: {},
    },

    baseOptions: {
      routeName: 'default',
      params: [{ paramName: 'id', paramAttribute: 'id' }],
      trigger: true,
    },

    initialize: function() {
      doublePressOptions = _.extend({}, this.baseOptions, this.getOption('doublePressOptions'));

      this.view.on('tableView:row:double:press', this.onDoublePress);
      this.view.on('row:double:press', this.onRowDoublePress);
    },

    onDoublePress: function(table, row) {
      var routeName = doublePressOptions.routeName,
        routeParams = _getRouteParams(doublePressOptions.params, row.model),
        trigger = doublePressOptions.trigger;

      RouteHelper.navigate(routeName, routeParams, { trigger: trigger });
    },

    onRowDoublePress: function(row) {
      var routeName = doublePressOptions.routeName,
        routeParams = _getRouteParams(doublePressOptions.params, row.model),
        trigger = doublePressOptions.trigger;

      RouteHelper.navigate(routeName, routeParams, { trigger: trigger });
    },
  });

  module.exports = ShowDetailOnTableRowDoublePressBehavior;
});

